<script setup lang="ts">

import {BadgeAlertIcon, BadgeCheckIcon, BadgeInfoIcon, BadgeXIcon } from "lucide-vue-next";
import {computed} from "vue";
import {ColorType} from "../../enums/ColorType";

interface Props {
    title: string,
    color?: ColorType,
}

const props = withDefaults(defineProps<Props>(), {
    color: ColorType.primary,
})

const backgroundColor = computed(() => `bg-${props.color}-50`)
const iconColor = computed(() => `text-${props.color}-400`)
const titleColor = computed(() => `text-${props.color}-800`)
const descriptionColor = computed(() => `text-${props.color}-700`)
const borderColor = computed(() => `border-${props.color}-700`)

const icon = computed(() => {
    switch (props.color) {
        case ColorType.succes:
            return BadgeCheckIcon
        case ColorType.warning:
            return BadgeAlertIcon
        case ColorType.error:
            return BadgeXIcon
        case ColorType.primary:
        case ColorType.secondary:
        default:
            return BadgeInfoIcon;
    }
})

</script>

<template>
    <div class="rounded-md p-4 border-1" :class="[backgroundColor, borderColor]">
        <div class="flex">
            <div class="shrink-0">
                <component :is="icon" class="h-5 w-5" :class="[iconColor]" aria-hidden="true"></component>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-bold" :class="[titleColor]">{{ title || color }}</h3>
                <div class="text-sm" :class="[descriptionColor]">
                    <slot/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
